module.exports = __webpack_public_path__ + "static/media/sign_load.84f5f6ca.png";